import * as tslib_1 from "tslib";
import { AuthService } from '../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PlayerService } from '../services/player.service';
export class CabinetComponent {
    constructor(authService, playerService, router, route) {
        this.authService = authService;
        this.playerService = playerService;
        this.router = router;
        this.route = route;
        this.hebrewCollator = new Intl.Collator(["he", "en"], {
            usage: "sort",
            sensitivity: "base",
            ignorePunctuation: true,
            numeric: true,
        });
        this.route.params.subscribe(p => {
            // if this is not multiuser or not authenticated then logout
            if (!this.user.children.length) {
                this.logout();
            }
        });
    }
    get user() { return this.authService.user; }
    get currentUser() { return this.authService.currentUser; }
    get childrenSorted() {
        const children = (this.user && this.user.children) ? this.user.children : [];
        return [...children].sort((a, b) => {
            const aName = this.normalizeNameForSort((a.nick || a.name || '').toString());
            const bName = this.normalizeNameForSort((b.nick || b.name || '').toString());
            return this.hebrewCollator.compare(aName, bName);
        });
    }
    logout() {
        this.playerService.stop();
        this.authService.logout();
        this.router.navigateByUrl("/auth/login");
    }
    setCurrentUser(newUser) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (newUser.name !== this.currentUser.name && newUser.active) {
                this.playerService.stop();
                newUser.isChildUser = true;
                this.authService.setCurrentUser(newUser);
                yield this.playerService.start();
                this.router.navigateByUrl("/tab1");
            }
        });
    }
    getUserClass(user) {
        if (this.currentUser.name === user.name) {
            return "active";
        }
        else if (!user.active) {
            return "disabled";
        }
        else {
            return "";
        }
    }
    normalizeNameForSort(value) {
        const withoutMarks = value.normalize("NFKD").replace(/[\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7]/g, "");
        return withoutMarks.trim();
    }
}
